import * as angular from 'angular';

import { AccordionContentDirectiveFactory } from './directives/accordion-content-directive';
import { AccordionDirectiveFactory } from './directives/accordion-directive';
import { AccordionHeaderDirectiveFactory } from './directives/accordion-header-directive';
import { AccordionPanelDirectiveFactory } from './directives/accordion-panel-directive';
import {
    ButtonDirectiveFactory,
    IconButtonDirectiveFactory,
    LinkButtonDirectiveFactory
} from './directives/button-directive';
import { ButtonGroupDirectiveFactory } from './directives/button-group-directive';
import { ChartDirectiveFactory } from './directives/chart';
import { CheckboxDirectiveFactory } from './directives/checkbox-directive';
import { InputDirectiveFactory } from './directives/input-directive';
import { LegendDirectiveFactory } from './directives/legend-directive';
import { MenuDirectiveFactory } from './directives/menu-directive';
import { ModalDirectiveFactory } from './directives/modal-directive';
import { PasswordDirectiveFactory } from './directives/password-directive';
import { PrintDirectiveFactory } from './directives/print-directive';
import { PrintPageDirectiveFactory } from './directives/print-page-directive';
import { RadioDirectiveFactory } from './directives/radio-directive';
import { SelectItemDirectiveFactory } from './directives/select-item-directive';
import { SelectListDirectiveFactory } from './directives/select-list-directive';
import { SvgDirectiveFactory } from './directives/svg-directive';
import { TableDirectiveFactory } from './directives/table-directive';
import { TabsContentDirectiveFactory } from './directives/tabs-content-directive';
import { TabsDirectiveFactory } from './directives/tabs-directive';
import { TabsPanelDirectiveFactory } from './directives/tabs-panel-directive';
import { TabsTitleDirectiveFactory } from './directives/tabs-title-directive';
import { YearRangeDirectiveFactory } from './directives/year-range-directive';
import { percentFilter } from './filters/percent-filter';
import { resultFilter } from './filters/result-filter';
import { PasteService } from './services/paste-service';
import { StorageService } from './services/storage-service';

export const module = angular
    .module('fcShared', [])
    .filter('fcPercent', percentFilter)
    .filter('fcResult', resultFilter)
    .service('fcStorageService', StorageService)
    .service('fcPasteService', PasteService)
    .directive('fcSvg', SvgDirectiveFactory)
    .directive('fcButton', ButtonDirectiveFactory)
    .directive('fcIconButton', IconButtonDirectiveFactory)
    .directive('fcLinkButton', LinkButtonDirectiveFactory)
    .directive('fcButtonGroup', ButtonGroupDirectiveFactory)
    .directive('fcRadio', RadioDirectiveFactory)
    .directive('fcCheckbox', CheckboxDirectiveFactory)
    .directive('fcInput', InputDirectiveFactory)
    .directive('fcPassword', PasswordDirectiveFactory)
    .directive('fcSelectList', SelectListDirectiveFactory)
    .directive('fcSelectItem', SelectItemDirectiveFactory)
    .directive('fcMenu', MenuDirectiveFactory)
    .directive('fcTable', TableDirectiveFactory)
    .directive('fcModal', ModalDirectiveFactory)
    .directive('fcAccordion', AccordionDirectiveFactory)
    .directive('fcAccordionPanel', AccordionPanelDirectiveFactory)
    .directive('fcAccordionHeader', AccordionHeaderDirectiveFactory)
    .directive('fcAccordionContent', AccordionContentDirectiveFactory)
    .directive('fcTabs', TabsDirectiveFactory)
    .directive('fcTabsPanel', TabsPanelDirectiveFactory)
    .directive('fcTabsTitle', TabsTitleDirectiveFactory)
    .directive('fcTabsContent', TabsContentDirectiveFactory)
    .directive('fcPrint', PrintDirectiveFactory)
    .directive('fcPrintPage', PrintPageDirectiveFactory)
    .directive('fcLegend', LegendDirectiveFactory)
    .directive('fcYearRange', YearRangeDirectiveFactory)
    .directive('fcChart', ChartDirectiveFactory);
